<template>
  <v-container>
    <v-tabs
      v-model="tabIndex"
      slider-color="secondary"
      color="primary"
      background-color="transparent"
      active-class="secondary"
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="'tab' + index"
      >
        <v-icon left>{{tab.icon}}</v-icon>
        {{tab.title}}
      </v-tab>
    </v-tabs>
    <v-fade-transition mode="out-in">
      <component :is="tabs[tabIndex].component" :key="'component' + tabIndex"/>
    </v-fade-transition>
  </v-container>
</template>

<script>
import MallsList from '@/components/Mall/MallsList'
import MallsCalendar from '@/components/Mall/MallsCalendar'
import MallsFlux from '@/components/Mall/MallsFlux'
export default {
  components: { MallsList, MallsCalendar, MallsFlux },
  data: () => ({
    tabIndex: 0,
  }),
  computed: {
    tabs () {
      return [
        {title: 'Liste des centres', icon: 'list', component: MallsList},
        {title: 'Calendrier des ouvertures', icon: 'event_available', component: MallsCalendar},
        {title: 'Saisie des Flux', icon: 'transfer_within_a_station', component: MallsFlux}
      ]

    }
  }

}
</script>
